import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

const AutoLogoutAndGuard = ({ children }) => {
  const navigate = useNavigate();

  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);

  // 5 Minutes
  const INACTIVITY_LIMIT = 5 * 60 * 1000;

  // Logout Function
  const performLogout = () => {
    console.log("==================================");
    console.log("🚪 Auto Logout Triggered");
    console.log("Logout Time :", new Date().toLocaleString());
    console.log("==================================");

    localStorage.removeItem("currentUser");
    localStorage.removeItem("currentUserName");
    localStorage.removeItem("currentUserEmployeeID");
    localStorage.removeItem("currentSelectedDepartment");
    localStorage.removeItem("currentUserLoginStatus");

    navigate("/");
  };

  return <>{children}</>;
};

export default AutoLogoutAndGuard;